<app-modal [display]="true">
  <app-modal-header class="is-flex is-justify-space-between">
    <app-text class="text-18 is-family-semiBold">{{ 'common-app.__ADD_ROOM' |  AsyncLang | async }}</app-text>
    <app-icon [routerLink]="['..']" skipLocationChange="true" name="close" class="text-24"></app-icon>
  </app-modal-header>
  <app-modal-body>

    <div class="description has-spacing-bottom-l">
      <app-text [text]="'common-app.__UNPLACED_PRODUCT_WEBAPP_ADDROOM_EXPLICATION' | AsyncLang | async"></app-text>
    </div>
    <form  [formGroup]="formGroup" (ngSubmit)="submit()">
      <div class="is-flex is-column gap-24">
        <div class="is-flex is-column gap-8">
          <app-text class="is-family-medium">{{ 'common-app.__UNPLACED_PRODUCT_WEBAPP_ADDROOM_TYPE' |  AsyncLang | async }}</app-text>
          <app-dropdown formControlName="type">
            <div class="is-flex gap-16 is-align-center" dropdown-value>
              <app-icon class="text-32" [name]="RoomsAssets[type.value.value]?.icon"></app-icon>
              <app-dropdown-value class="is-family-semiBold"></app-dropdown-value>
            </div>

            <ng-container *ngFor="let type of roomTypes">
              <app-dropdown-item [value]="type.value" [label]="type.label"></app-dropdown-item>
            </ng-container>
          </app-dropdown>
        </div>

        <div class="is-flex is-column gap-8">
          <app-text class="is-family-medium">{{ 'common-app.__NAME' |  AsyncLang | async }}</app-text>
          <div class="input-name">
            <app-input-text formControlName="name" updateOn="change" autocomplete="off" [hasEdit]="false"></app-input-text>
          </div>
        </div>

        <lay-button class="is-flex-button">
          <button class="is-primary-button" [disabled]="formGroup.invalid">
            <app-text [text]="'legrand-app.__LEG_SAVE' | LANG"></app-text>
          </button>
        </lay-button>
      </div>
    </form>

  </app-modal-body>
</app-modal>